
export default {
  share: {
    fullUrl: 'Completa',
    shortUrl: 'encurtar',
    urlCopied: 'URL copiada para a área de transferência.',
    clickToCopy: 'Clique para copiar a URL',
    share: 'Compartilhar (clique para copiar)',
    shareLink: 'Compartilhar link',
    short: 'Encurtar URL',
    copyUrlInfo: 'Você também pode copiar o link a partir da barra de endereços do seu navegador.',
    urlShortened: 'URL encurtada',
    shorteningNotPossible: 'Não foi possível gerar uma URL curta. Por favor, use a URL completa.',
    embedCodeCopied: 'Código para incorporação de mapa copiado',
    embed: 'Código para incorporar (clique para copiar)',
    embedInstructions: 'Use este código para incorporar o mapa ORS em um website'
  }
}
